export default __webpack_public_path__ + "static/media/danji_cg_04.662c7d71.jpg";